import { render } from "./download.vue?vue&type=template&id=a324083c&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=a324083c&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/xiaocanghui/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a324083c"]])

export default __exports__